export const SET_CURRENT_RIDE_CATEGORIES = 'SET_CURRENT_RIDE_CATEGORIES';

export const actionSetCurrentRideCategories = rideCategories => ({
    type: SET_CURRENT_RIDE_CATEGORIES,
    payload: rideCategories
})
